import { Plus } from 'lucide-react';

import { Badge } from '@/shared/components/shadcn/badge';
import { Button } from '@/shared/components/shadcn/button';
import { Skeleton } from '@/shared/components/shadcn/skeleton';
import type { CampaignListFilter } from '../../hooks';

export function EmptyState({ onCreate }: { onCreate: () => void }) {
  return (
    <div className="border-border bg-background/90 rounded-[28px] border border-dashed px-8 py-14 text-center shadow-sm">
      <div className="mx-auto max-w-xl space-y-4">
        <Badge
          variant="outline"
          className="rounded-full px-3 py-1 text-[11px] tracking-[0.16em] uppercase"
        >
          No campaigns yet
        </Badge>
        <div className="space-y-2">
          <h2 className="text-foreground text-2xl font-semibold tracking-tight">
            Create your first campaign workspace
          </h2>
          <p className="text-muted-foreground text-sm leading-6">
            Start with a campaign to combine creator tracking, post URLs, keywords, and platform
            coverage in one place.
          </p>
        </div>
        <div className="pt-2">
          <Button onClick={onCreate}>
            <Plus className="size-4" />
            Create campaign
          </Button>
        </div>
      </div>
    </div>
  );
}

export function FilteredEmptyState({
  searchQuery,
  selectedFilter,
}: {
  searchQuery: string;
  selectedFilter: CampaignListFilter;
}) {
  return (
    <div className="border-border bg-background/95 rounded-[28px] border px-8 py-14 text-center shadow-sm">
      <div className="mx-auto max-w-xl space-y-4">
        <Badge
          variant="outline"
          className="rounded-full px-3 py-1 text-[11px] tracking-[0.16em] uppercase"
        >
          No matching campaigns
        </Badge>
        <div className="space-y-2">
          <h2 className="text-foreground text-2xl font-semibold tracking-tight">
            Nothing matches the current filters
          </h2>
          <p className="text-muted-foreground text-sm leading-6">
            {searchQuery.trim()
              ? `No campaigns matched "${searchQuery.trim()}".`
              : `No ${selectedFilter} campaigns matched the current view.`}
          </p>
        </div>
      </div>
    </div>
  );
}

export function CampaignListLoading() {
  return (
    <div className="grid gap-4">
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton key={index} className="h-35" />
      ))}
    </div>
  );
}
